import { defineStore } from "pinia"

export interface SupportStoreType {
  feedback: FeedbackType
}

export interface FeedbackType {
  context?: string
  designation?: string
}

export const useSupportStore = defineStore("pinia-supportStore", {
  persist: false,

  state: (): SupportStoreType => ({
    feedback: {},
  }),

  actions: {
    setFeedbackData(context?: string, designation?: string) {
      this.feedback = {}
      this.feedback.context = context
      this.feedback.designation = designation
    },
  },
})
